import styled from "styled-components"
import flyers from "../../assets/images/schema-flyers.png"
import carte_visite from "../../assets/images/schema-visite.png"
import site_web from "../../assets/images/schema-site.png"
import {
    ContentWrapperAccueilSection,
    TextWrapperAccueilSection,
    AccueilSectionWrapper,
} from "./AccueilElements.tsx"


const TextAccueilSection = styled.p`
    font-family: "Inter", sans-serif;
    font-size: 24px;
    margin: 0;
    line-height: 1.5;
    margin-bottom: 2vw;
`

const ImgWrapper = styled.div`
    width: 45%;
    margin-top: 2vw;
    max-height: 35vw;

    @media (max-width: 768px) {
        margin-left: auto;
        margin-right: auto;
    }
`

const ImgSite = styled.img`
    z-index: 1;
    width: 99%;
    position: relative;
    top: -22vw;
`

const ImgFlyers = styled.img`
    z-index: 2;
    width: 39%;
    position: relative;
    top: 10vw;
    left: 23vw;
`

const ImgVisite = styled.img`
    z-index: 3;
    width: 46%;
    position: relative;
    top: 8.5vw;
    right: 5vw;
`

function AccueilSchemaSection() {
    return (
        <AccueilSectionWrapper>
            <ContentWrapperAccueilSection>
                <ImgWrapper>
                    <ImgFlyers src={flyers} alt="Flyers" />
                    <ImgVisite src={carte_visite} alt="Carte de visite" />
                    <ImgSite src={site_web} alt="Site web" />
                </ImgWrapper>

                <TextWrapperAccueilSection>
                    <TextAccueilSection>
                        Je peux vous aider à créer des designs qui vous ressemblent : 
                        cartes de visite, flyers ou sites web.
                    </TextAccueilSection>
                    <TextAccueilSection>
                        Grâce à mes projets pro et perso, 
                        j’ai acquis une vraie expérience en design 
                        graphique et développement web.
                    </TextAccueilSection>
                    <TextAccueilSection>
                        J’allie créativité et technique 
                        pour vous proposer des résultats soignés, 
                        pensés pour mettre en valeur votre activité.
                    </TextAccueilSection>
                </TextWrapperAccueilSection>
            </ContentWrapperAccueilSection>
        </AccueilSectionWrapper>
    )
}

export default AccueilSchemaSection
